import styled from 'styled-components';

export const ContainerLoading = styled.div`
    flex: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Container = styled.div`
    margin-left: 5rem;
    margin-right: 1rem;
`;

// export const GoalsContainer = styled.div`
//     display: flex;
//     align-items: center;
//     flex-direction: column;
//     width: 100%;
//     margin: 25px 0;
//     position: relative;

//     @media (max-width: 460px){
//         width: 80%;
//     }
// `;

export const Content = styled.div`
    margin-bottom: 2.5rem;
    overflow: scroll;
    position: relative;
        
    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;  

    .scroll-grid{
        width: 100%;
        height: 100%;
        position: relative;
        overflow: scroll;

        &::-webkit-scrollbar{
            display: none;
       
        }
    }

`;

export const Button = styled.div`
    padding: 0.5rem;
    border-radius: 5px;
    background: #2e9699;
    color: #FFF;
    margin: 1rem auto;
    max-width: 300px;
    cursor: pointer;
    opacity: ${props => props.loadingButton ? 0.5 : 1};
    pointer-events: ${props => props.loadingButton ? 'none' : 'all'};
    text-align: center;
`;


export const ButtonFixedContainer = styled.div`
    position: fixed;
    bottom: 0;
    width: 95%;
    padding: 5px 0 5px 0;
    background: #fff;
    z-index: 12;

    div{
        max-width: 10rem;
        margin: 0 auto;
    }
`;












